import * as v from 'valibot';

import type { SimpleStatistics } from '../types';

export const simpleStatisticsSchema: v.GenericSchema<SimpleStatistics> =
  v.object({
    casesStatistics: v.object({
      ground: v.number('Ground cases count is missing'),
      airGround: v.number('Air/Ground cases count is missing'),
      tmdxShare: v.number('TMDX share is missing'),
      allCases: v.number('All cases count is missing'),
      startDate: v.string('Start date is missing'),
    }),
    fleetAvailability: v.number('Fleet availability is missing'),
    aviationStatistics: v.object({
      crewTotalHours: v.number('Crew total hours are missing'),
      crewOnCaseHours: v.number('Crew on case hours are missing'),
      crewOnNonCaseHours: v.number('Crew on non-case hours are missing'),
      crewWaitingForCaseHours: v.number(
        'Crew waiting for case hours are missing',
      ),
      maintenancesHours: v.number('Maintenance hours are missing'),
      noCrewHours: v.number('No crew hours are missing'),
      days: v.number('Days count is missing'),
    }),
    lastUpdated: v.string('Last updated timestamp is missing'),
  });
